module.exports = __webpack_public_path__ + "img/news_default.c5945df0.jpg";